'use client';

import Script from 'next/script';
import { FC } from 'react';
import { useExternalServiceStore } from 'src/stores/externalServiceStore';
import { shallow } from 'zustand/shallow';

/**
 * Component in charge of conditionally loading the recaptcha script
 */
export const Recaptcha: FC = () => {
  const { setRecaptchaReady, shouldLoadRecaptcha } = useExternalServiceStore(
    ({ setRecaptchaReady, shouldLoadRecaptcha }) => ({ setRecaptchaReady, shouldLoadRecaptcha }),
    shallow,
  );

  if (!shouldLoadRecaptcha) {
    return null;
  }

  return (
    <Script
      id="recaptcha"
      key="recaptcha"
      data-testid="recaptcha-script"
      src={`https://www.google.com/recaptcha/api.js?render=${process.env.RECAPTCHA_TOKEN}`}
      onLoad={() => {
        setRecaptchaReady(true);
      }}
    />
  );
};
